const FileFormatMapper = (fileFormat, page = "") => {
  if (!fileFormat) {
    return `https://q2pay.in/new_assets/common/file_format/default_image.svg`;
  }

  if (page) {
    return `https://q2pay.in/new_assets/common/file_format/${fileFormat}.svg`;
  } else {
    try {
      return `https://q2pay.in/new_assets/common/file_format/${fileFormat}.svg`;
    } catch (error) {
      return `https://q2pay.in/new_assets/common/file_format/default.svg`;
    }
  }
};

export default FileFormatMapper;
